/**
 * Status cells in tables: a cell that is just a status word ("Done", "On track", "Challenged", "Not started",
 * "Blocked") renders as a coloured chip, and "status:green|amber|red|grey" renders as a traffic-light dot.
 * Same rules in the web renderer (SlideRenderer.tsx) — keep in step.
 */
export type StatusTone = 'green' | 'amber' | 'red' | 'grey';
export interface CellStatus { kind: 'chip' | 'dot'; tone: StatusTone; label: string }

const WORDS: Record<StatusTone, string[]> = {
  green: ['done', 'complete', 'completed', 'on track', 'on-track', 'live', 'approved', 'delivered', 'yes', 'green'],
  amber: ['challenged', 'at risk', 'at-risk', 'delayed', 'pending', 'in progress', 'in review', 'partly', 'amber', 'yellow'],
  red: ['blocked', 'late', 'off track', 'off-track', 'critical', 'missed', 'no', 'red', 'failed'],
  grey: ['not started', 'tbd', 'n/a', 'na', 'planned', 'grey', 'gray', 'paused'],
};

export const STATUS_COLORS: Record<StatusTone, { bg: string; text: string; dot: string }> = {
  green: { bg: '#DCFAE6', text: '#067647', dot: '#12B76A' },
  amber: { bg: '#FEF0C7', text: '#B54708', dot: '#F79009' },
  red: { bg: '#FEE4E2', text: '#B42318', dot: '#F04438' },
  grey: { bg: '#F2F4F7', text: '#475467', dot: '#98A2B3' },
};

export function cellStatus(cell: unknown): CellStatus | null {
  if (typeof cell !== 'string') return null;
  const t = cell.trim(); if (!t) return null;
  const dot = /^status:\s*(green|amber|yellow|red|grey|gray)$/i.exec(t);
  if (dot) { const w = dot[1].toLowerCase(); return { kind: 'dot', tone: w === 'yellow' ? 'amber' : w === 'gray' ? 'grey' : (w as StatusTone), label: '' }; }
  const lower = t.toLowerCase();
  for (const tone of Object.keys(WORDS) as StatusTone[]) if (WORDS[tone].includes(lower)) return { kind: 'chip', tone, label: t };
  return null;
}
